export default "__VITE_ASSET__af5a7b36__"